import { BlobServiceClient } from '@azure/storage-blob';
import { Buffer } from 'buffer';
import { convertFileToArrayBuffer } from '../lib/convert-file-to-arraybuffer.ts';


const CONTAINER_IMAGE_NAME = process.env.REACT_APP_CONTAINER_IMAGE_NAME ?? "";
const CONTAINER_FILE_NAME = process.env.REACT_APP_CONTAINER_FILE_NAME ?? "";
const STORAGE_ACCOUNT = process.env.REACT_APP_STORAGE_ACCOUNT ?? "";
//const sasToken = 'se=2025-01-08T20%3A59%3A43Z&sp=rw&sv=2025-01-05&sr=c&sig=9yT/zrduNC3O9CINhR/M91whGQyuTWryTUuy4fBMASA%3D';
const GET_SAS_TOKEN_URL = process.env.REACT_APP_FUNCTION_URL ?? "";
const SAS_TOKEN_URL_CODE = process.env.REACT_APP_FUNCTION_AAA_SAS_API_URL_CODE ?? "";


export const uploadFile = async (file: File, sasTokenGen, userName, uniqueId) => {

  const blobServiceClient = new BlobServiceClient(
    `https://${STORAGE_ACCOUNT}.blob.core.windows.net/?${sasTokenGen}`
  );

  var CONTAINER_NAME = "";
  if (file && file.type.startsWith('image/')) {
    CONTAINER_NAME = CONTAINER_IMAGE_NAME;
  }
  else {
    CONTAINER_NAME = CONTAINER_FILE_NAME;
  }

  const containerClient = blobServiceClient.getContainerClient(CONTAINER_NAME);

  const blobClient = containerClient.getBlockBlobClient(uniqueId + "/" + file.name);

  const fileArray: void | ArrayBuffer | undefined = await convertFileToArrayBuffer(file as File)
    .then((fileArrayBuffer) => {
      if (
        fileArrayBuffer === null ||
        fileArrayBuffer.byteLength < 1 ||
        fileArrayBuffer.byteLength > 256000
      )
        return;

      return fileArrayBuffer;
    })
    .catch((error) => {
      console.error(error);
      return;
    });

  const fileArrayBuffer: ArrayBuffer | null = fileArray as ArrayBuffer | null;
  if (fileArrayBuffer === null) {
    console.error('Failed to convert file to array buffer');
    return;
  }
  else {
    await blobClient.uploadData(fileArrayBuffer, {
      blobHTTPHeaders: {
        blobContentType: file.type
      }
    })
      .then(() => {
        console.log('Successfully finished upload');
        return "Success";
      })
      .catch((error: unknown) => {
        if (error instanceof Error) {
          const { message, stack } = error;
          console.error(
            `Failed to finish upload with error : ${message} ${stack || ''}`
          );
        } else {
          console.error(error as string);
        }
      });
  }
};

export async function getSASToken(accessToken, containerName) {

  const responseToken = await fetch(`${GET_SAS_TOKEN_URL}/getSASToken/${containerName}`, {
    method: 'GET',
    mode: 'cors',
    headers: {
      "Content-Type": "application/json",
      "x-functions-key": `${SAS_TOKEN_URL_CODE}`,
      //"Authorization": `Bearer ${accessToken}`
    }
  })
    .then((response) => {
      console.log("Response", response);
      return response.json();
    })
    .then((data) => {
      console.log("Data", data);
      return data.sas_token;
    })
    .catch((error) => { console.log(error) });

  return responseToken;
}